module.exports = __webpack_public_path__ + "static/media/icra24friendsanddad.40078059.jpeg";